import { Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { supabase } from './lib/supabase'
import type { User } from '@supabase/supabase-js'
import LandingPage from './pages/LandingPage'
import Auth from './pages/Auth'
import Dashboard from './pages/Dashboard'
import UploadNotes from './components/UploadNotes'
import TaskReview from './components/TaskReview'
import TaskReviewEnhanced from './components/TaskReviewEnhanced'
import TaskHistory from './components/TaskHistory'
import DataPrivacySettings from './components/DataPrivacySettings'
import Success from './pages/Success'
import SprintReport from './pages/SprintReport'

function App() {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Get current session
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null)
      setLoading(false)
    })

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null)
    })

    return () => subscription.unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-500"></div>
      </div>
    )
  }

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={user ? <Navigate to="/dashboard" /> : <LandingPage />} />
        <Route path="/auth" element={user ? <Navigate to="/dashboard" /> : <Auth />} />
        
        {/* Protected routes */}
        <Route path="/dashboard/*" element={user ? <Dashboard /> : <Navigate to="/auth" />}>
          <Route index element={<UploadNotes />} />
          <Route path="review" element={<TaskReviewEnhanced />} />
          <Route path="sprint-report" element={<SprintReport />} />
          <Route path="history" element={<TaskHistory />} />
          <Route path="settings" element={<DataPrivacySettings />} />
          <Route path="success" element={<Success />} />
        </Route>
      </Routes>
    </div>
  )
}

export default App 